module.exports = __webpack_public_path__ + "site/img/60.93aadaf9.jpg";